import cbaPreapprove from './cba-preapprove';
import companySignupConfirm from './companySignupConfirm';
import countries from './countries';
import login from './login';
import mfa from './mfa';
import preapprove from './preapprove';
import shared from './shared';
import signup from './signup';
import sso from './sso';

export default {
  cbaPreapprove,
  countries,
  login,
  mfa,
  preapprove,
  shared,
  signup,
  companySignupConfirm,
  sso
};
